import {Component, EventEmitter, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {SnackBarService} from "../../../services/snack-bar.service";
import {LoadingService} from "../../../services/LoadingService";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute, Router} from "@angular/router";
//import {Partial} from "aws-sdk/clients/cloudsearchdomain";
import {TaxPlanningService} from "../../../tpiq-services/tax-planning.service";
import {QuestionnairesSurveysService} from "../../../services/questionnaires-surveys.service";
import {takeUntil} from "rxjs/operators";
import {CollaborationService} from "../../../services/Collaboration.service";
import {ToastService} from "../../../services/Toast.service";
import {StateService} from "../../../services/StateService";
import {DateFormater} from "../../../services/DateFormatter.service";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ErrorHandlerService} from "../../../services/error-handler.service";
import {Session} from "../../../services/Session";
import {AWSKeys} from "../../../services/AWSKeys.service";
import {DynamicFormComponent} from "../question-based-answers/dynamic-form/dynamic-form.component";
import {QuestionBase} from "../question-based-answers/question-base/question-base";
import {InvalidControlScrollContainerDirective} from "../question-based-answers/invalid-control-scroll-container.directive";
import {LockedQsComponent} from "../locked-qs/locked-qs.component";
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import {PageTitleService} from "../../../services/PageTitle";


declare const _: any;
declare const moment: any;
declare let jQuery: any;

@Component({
  selector: 'app-client-answers-qs',
  standalone: true,
  imports: [CommonModule, FormsModule, InvalidControlScrollContainerDirective, LockedQsComponent, DynamicFormComponent,MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTabsModule,],
  templateUrl: './client-answers-qs.component.html',
  styleUrl: './client-answers-qs.component.scss',
   encapsulation: ViewEncapsulation.None,
})
export class ClientAnswersQsComponent implements OnInit, OnDestroy {
  user: any;
  userId: string;
  isCustomer: boolean;
  org: string;
  sections: Array<{ id: string, name: string, order: number, questions?: Partial<QuestionBase<string | number>>[] }> = [];
  
  recurringFilters: Array<any> = [];
  lock: boolean;
  done: boolean;
  loader: boolean;
  allSections: Array<any> = [];
  questionnaireId: string;
  questionnaireName: string;
  questionnaireBucket: string;
  questionnaireBucketValue: string;
  clientId: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  selectedYear: any;
  s3Credentials: any;
  s3Data: any = {};
  uploadBucket: string;
  s3TokenRefresh: any;
  selectedIndex = 0;
  currentIndex = 0;
  @ViewChild(DynamicFormComponent) public DynamicFormComponent;
  questionnairesList: Array<any> = [];
  showData: boolean;
  reviewSectionQuestions: Array<any>;
  customerQuestionnaires: boolean = false;
  // Bumped per fetch so responses from a superseded fetch (Year or Questionnaire changed
  // mid-load) can be dropped instead of appended on top of the new sections.
  fetchGeneration = 0;
  sectionsLoaded = 0;

  constructor(
    private route: ActivatedRoute,
    private qsService: QuestionnairesSurveysService,
    private errorHandler: ErrorHandlerService,
    private loadingService: LoadingService,
    private awsKeysService: AWSKeys,
    private dateFormater: DateFormater,
    public dialog: MatDialog,
    private switchBoard: SwitchBoard,
    public snackBar: SnackBarService,
    private stateService: StateService,
    private router: Router,
    private toastService: ToastService,
    private taxPlanningService: TaxPlanningService,
    private collaborationService: CollaborationService,
    private titleService: PageTitleService
  ) {
  }

  ngOnInit(): void {
    this.user = Session.getUser();
    this.userId = Session.getUser().id;
    this.isCustomer = this.user.isCustomer;
    this.org = Session.getOrg();
    this.refreshToken();

    // Added the condition for customer Questionaries
        this.route.queryParamMap.subscribe(params => {
            const isCustomerQuestionnaires = params.has('customerQuestionnaires') && params.get('customerQuestionnaires') === 'true';
            if (isCustomerQuestionnaires) {
                this.customerQuestionnaires = true;
                this.user = Session.getUser('delegatedFrom');
                this.userId = Session.getUser('delegatedFrom').id;
            }
          });

    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.clientId = params.channelId;
      if (!this.clientId) {
        this.clientId = Session.get('client').id || '';
        this.titleService.setPageTitle(`Questionnaire`);
      }
      this.getQuestionnaireData();
    });

    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });
  }

  getQuestionnaireData(){
    this.qsService.getQuestionnaireDetails(this.org, this.user.id).subscribe(questionnaireDetails => {
      this.loadingService.triggerLoadingEvent(false);
      this.questionnaireId = questionnaireDetails.questionnaireId;
      this.questionnaireName = "TPIQ Questionnaire";
      const buckets = questionnaireDetails.buckets || [];
      if (buckets && buckets.length > 0) {
        this.questionnaireBucketValue = buckets[0].bucketvalue;
      }
      this.fetchClientQuestions();
    }, error => {});
  }

  ngOnDestroy(): void {
    if (this.s3TokenRefresh) {
      clearInterval(this.s3TokenRefresh);
    }
  }

  fetchClientQuestions(): void {
    this.loadingService.triggerLoadingEvent(true);
    const generation = ++this.fetchGeneration;
    this.sectionsLoaded = 0;
    this.qsService.getClientQuestions(this.org, this.userId, this.clientId, this.questionnaireId, this.questionnaireBucketValue)
      .subscribe({
        next: ({sections, questions, recurringFilters, done, lock}) => {
          if (!this.isCurrentFetch(generation)) {
            return;
          }
          this.sections = [];
          this.allSections = sections;
          this.recurringFilters = recurringFilters;
          this.checkRecurringBucket(this.recurringFilters);
          this.lock = lock;
          if (this.lock && this.isCustomer) {
            this.dialog.open(LockedQsComponent);
          }
          this.done = done;
          this.sections.push(this.allSections[0]);
          _.forEach(sections, (section, index) => {
            section.questions = [];
            this.filterBySection(index, generation);
          });
          this.addQsToSection(questions, 0, generation);
          this.showData = true;
          this.loadingService.triggerLoadingEvent(false);
        },
        error: error => {
          // A stale failure must not clear the loader or raise a toast naming a selection
          // the user has already moved off.
          if (!this.isCurrentFetch(generation)) {
            return;
          }
          this.handleError(error);
        }
      });
  }

  // True when `generation` still identifies the newest fetch. Undefined means an untracked
  // caller (the template and older call sites), which is always treated as current.
  isCurrentFetch(generation?): boolean {
    return generation === undefined || generation === this.fetchGeneration;
  }

  filterBySection(index, generation?): void {

    if (index !== 0 && this.allSections[index] && this.allSections[index].questions.length === 0) {
      this.loader = true;
      this.qsService
        .getClientQuestionsBySection(this.org, this.userId, this.clientId, this.questionnaireId, this.allSections[index].id, this.questionnaireBucketValue)
        .subscribe((response) => {
          this.addQsToSection(response, index, generation);
          if (this.isCurrentFetch(generation)) {
            this.loader = false;
          }
        }, error => {
          if (!this.isCurrentFetch(generation)) {
            return;
          }
          // Still count it, or one failed section stops Review & Submit being built at all.
          this.markSectionLoaded(generation);
          this.handleError(error);
        });
    } else if (index !== 0) {
      // Nothing was dispatched for this index, so count it here. Index 0 is counted by its
      // own addQsToSection call.
      this.markSectionLoaded(generation);
    }
  }

  addQsToSection(questions, index?, generation?): void {
    if (!this.isCurrentFetch(generation)) {
      return;
    }
    if (index && index !== 0) {
      if (questions && questions.questionsAnswer && questions.questionsAnswer.length > 0) {
        this.sections.push(this.allSections[index]);
      }
    }
    questions.questionsAnswer.forEach((question, idx) => {
      if (idx === 0) {
        question.showComments = true;
      }
      _.forEach(question.comments, (comment) => {
        comment.createdDate = this.updateDateTimeStamp(comment.createdDate);
        comment.editComment = false;
      });
      question.key = question.questionId + questions.sectionName;
      const sec = this.sections.find((section) => section.id === questions.sectionId);
      if (sec) {
        if (!sec.questions) {
          sec.questions = [];
        }
        sec.questions.push(question);
      }
    });
    this.sections.sort((a, b) => a.order - b.order);
    this.sections = [...this.sections];

    this.markSectionLoaded(generation);
  }

  // Review & Submit mirrors every other tab, so it can only be built once they have all
  // arrived. Rebuilding it on each response is what produced the duplicate tabs.
  markSectionLoaded(generation?): void {
    if (!this.isCurrentFetch(generation)) {
      return;
    }
    this.sectionsLoaded++;
    if (this.sectionsLoaded >= this.allSections.length) {
      this.checkForReviewSection();
    }
  }

  updateDateTimeStamp(date): any {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  updateQsAnswers($event): void {
    const sec = this.sections.find((section) => section.id === $event.sectionId);
    _.forEach(sec.questions, question => {
      _.forEach($event.questionsAnswer, response => {
        if (question.questionId === response.questionId) {
          question.answerId = response.answerId;
        }
      });
    });
    setTimeout(() => {
      if (this.sections.length - 1 > this.selectedIndex) {
        ++this.selectedIndex;
        this.currentIndex = this.selectedIndex;
      }
    });
  }

  onQuestionnaireChange($event): void {
    this.questionnaireId = $event.value;
    this.questionnaireBucket = '';
    this.questionnaireBucketValue = '';
    this.fetchClientQuestions();
  }

  onRecurringChange($event): void {
    this.questionnaireBucket = $event.value;
    const bucket = _.find(this.recurringFilters, {key: $event.value});
    this.questionnaireBucketValue = bucket.value;
    this.fetchClientQuestions();
  }

  checkRecurringBucket(filters): void {
    // fetchClientQuestions re-runs this on every load: after the user picks a
    // year, and after the route reuses this view for another client. Keep an
    // explicit selection only while it is still one of the available filters;
    // otherwise apply the current-year default. Without this the Year dropdown
    // was reset on a year change, or kept a stale value that is not in the new
    // filters (CU-868krk6ab #4).
    const stillValid = this.questionnaireBucket && _.find(filters, {key: this.questionnaireBucket});
    if (stillValid) {
      return;
    }
    const filter = _.find(filters, {current: true});
    if (filter) {
      this.questionnaireBucket = filter.key;
      this.questionnaireBucketValue = filter.value;
    }
  }

  gets3Credentials(): void {
    this.awsKeysService.getAWSKeys({org_id: this.org, user_id: this.userId})
      .subscribe(response => {
        this.s3Credentials = response;
        this.uploadBucket = response.bucket_id;
      }, error => {
        this.handleError(error);
      });
  }

  refreshToken(): void {
    const base = this;
    this.s3TokenRefresh = setInterval(() => {
      base.gets3Credentials();
    }, 45 * 60 * 1000);
  }

  changeSelectedIndex($event): void {
    this.selectedIndex = $event;
    const arrKeys = this.sections.map(el => el.id);
    if (this.selectedIndex !== this.currentIndex && !this.lock && this.isCustomer) {
      this.currentIndex = this.selectedIndex;
      this.switchBoard.onTab.next(this.currentIndex);
    }

    if(!this.customerQuestionnaires){
     // this.checkForReviewSection();
    }
  }

  checkForReviewSection(): void {
    if (this.sections.length) {
      this.reviewSectionQuestions = [];
      // Remove by identity. Popping the last entry deleted a real section whenever Submit
      // did not happen to sort last, and left the stale Submit tab behind to be counted twice.
      this.sections = this.sections.filter((section) => section.id !== 'Submit');
      // Section order values come from Qount and are arbitrary, so derive the last slot from
      // them rather than from the section count.
      const maxOrder = this.sections.reduce((max, section) => Math.max(max, Number(section.order) || 0), 0);
      const obj = {
        id: 'Submit',
        name: 'Review & Submit',
        order: maxOrder + 1,
        questions: []
      };
      _.forEach(this.sections, (section) => {
        _.forEach(section.questions, (question) => {
          question.showComments = false;
          this.reviewSectionQuestions.push(question);
        });
      });
      obj.questions = this.reviewSectionQuestions;
      this.sections.push(obj);
    }
    this.sections.sort((a, b) => a.order - b.order);
    this.sections = [...this.sections];
  }

  markLock(value): void {
    this.lock = value;
    this.qsService.lockQuestionnaire(this.org, this.userId, 'clients', this.clientId, this.questionnaireId, this.lock, this.questionnaireBucketValue)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (this.lock) {
          this.snackBar.showNotification(`Locked Successfully`, 'success');
        } else {
          this.snackBar.showNotification(`Unlocked Successfully`, 'success');
        }
      }, error => {
        this.handleError(error);
      });
  }

  exportToWord(){
    const sections = _.map(this.sections, (section) => {
      return {
        id: section.id,
        name: section.name
      };
    });
    const request = {
      clientId: this.clientId,
      sections
    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.downloadWordQuestionnaire(this.org, this.userId, this.questionnaireId, request)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        const blob = new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `TaxPlanIQ Questionnaire.docx`;
        link.click();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Download');
      });
  }


  markDone(value): void {
    this.done = value;
    const request = {
      status: 'Done',
      bucket: this.questionnaireBucketValue
    };
    this.qsService.markAsDone(this.org, this.userId, this.clientId, this.questionnaireId, request)
      .subscribe(response => {
        this.snackBar.showNotification(`Marked as Done`, 'success');
      }, error => {
        this.handleError(error);
      });
  }

  gotoDefaultPage(): void {
    const prevState = this.stateService.getPrevState();
    if (prevState && prevState.url) {
      prevState.url = prevState.url.split('(')[0];
    }
    if (prevState && prevState.key === 'organizer') {
      this.router.navigate([prevState.url]);
    } else {
      this.stateService.pop();
      this.router.navigate([prevState.url]);
    }
  }

  downloadQsPdf(): void {
    this.loadingService.triggerLoadingEvent(true);
    this.collaborationService
      .downloadPdf(this.clientId, Session.getOrg(), this.questionnaireBucketValue, this.questionnaireId, 'clients')
      .subscribe(
        data => {
          const blob = new Blob([data], { type: 'application/pdf' });
          const link = jQuery('<a></a>');
          link[0].href = URL.createObjectURL(blob);
          link[0].download = 'Questionnaire_' + this.questionnaireBucket + '.pdf';
          link[0].click();
          this.loadingService.triggerLoadingEvent(false);
        },
        error => {
          this.handleError(error);
        }
      );
  }

  handleError(error): void {
    this.loadingService.triggerLoadingEvent(false);
    this.loader = false;
    this.errorHandler.handleError(error);
  }

}
